import universal from 'react-universal-component';

export default universal(() => import('./RequestPassword2'));


// WEBPACK FOOTER //
// ./src/app/views/PasswordForceRequest/index.js